export const DEFAULT_ASSIGN = 'DEFAULT_ASSIGN';